import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { ReduxAlert } from '../shared/alert.component';
import PeriodDropdown from '../shared/periodDropdown.component';
import SecondaryMenu from '../menu/secondaryMenu.component';
import ReturnToProvisionGrid from './returnToProvisionGrid.component';
import { isLoadingReturnToProvisionSelector } from './store/selectors';

import {
  selectPeriodForRTP,
  uploadRTPAction,
  fetchInitialDataForRTPPage,
} from './store/actions';

import {
  periodsSelector,
} from '../shared/store/selectors';
import { returnToProvisionPropType } from './propTypes';

class ReturnToProvisionPage extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    periods: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    selectPeriodForRTP: PropTypes.func.isRequired,
    uploadRTPAction: PropTypes.func.isRequired,
    fetchInitialDataForRTPPage: PropTypes.func.isRequired,
    rtpDetails: PropTypes.arrayOf(returnToProvisionPropType).isRequired,
    returnToProvisionLoading: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    this.props.fetchInitialDataForRTPPage();
  }

  selectPeriod = selectedPeriod => {
    const { periods } = this.props;
    const value = selectedPeriod ? selectedPeriod.value : null;
    const period = periods.find(period => period.value === value);

    this.props.selectPeriodForRTP(period);
  };

  uploadRTPAction = selectedRtpChanges => {
    const { period } = this.props;
    const taxYear = period.taxYear; //eslint-disable-line

    this.props.uploadRTPAction(taxYear, selectedRtpChanges);
  };

  render() {
    const {
      period,
      rtpDetails,
      returnToProvisionLoading,
    } = this.props;

    const rtpChangeRows = rtpDetails.map((rtpChange, index) => ({
      ...rtpChange,
      rtpChangeId: index,
    }));

    return (
      <div className="return-to-provision">
        <SecondaryMenu>
          <PeriodDropdown
            onChange={this.selectPeriod}
          />
        </SecondaryMenu>

        <div className="page">
          <div className="container-fluid page-content-container">
            <ReduxAlert/>
            <div className="row no-gutters">
              <div className="col">
                <ReturnToProvisionGrid
                  rtpDetails={rtpChangeRows}
                  returnToProvisionLoading={returnToProvisionLoading}
                  period={period}
                  uploadRTPAction={this.uploadRTPAction}
                />
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default connect(state => ({
  period: state.shared.period,
  periods: periodsSelector(state),
  rtpDetails: state.returnToProvision.rtpDetails,
  returnToProvisionLoading: isLoadingReturnToProvisionSelector(state),
}),
{
  selectPeriodForRTP,
  uploadRTPAction,
  fetchInitialDataForRTPPage,
})(ReturnToProvisionPage);
